import axios from '@/axiosInterceptor';
import placeholderFormData from '@/common/placeholderFormData'; // temporary data from login

const state = () => ({
  isEldProvidersLoading: false,
  onboardingPacketBody: {},
  onboarding_id: null,
  id: null,
  status: null,
  connections: [],
  current_stage: 0,
  connect_subscriptions: null,
  broker_connect_channels: null,
  viewed_step_name: null,
  eld_providers: [],
  certified_eld_providers: [],
  oauth_eld_providers: [],
  totalEldCount: null,
  latest_carrier_eld_provider: null,
  hasLatestEldProviderLoaded: false,
  tax_classification_and_identifiers: null,
  has_attempted_completed_redirect: false,
  current_eld_integration: null,
  most_recent_eld_integration: null,
  current_eld_integration_has_loaded: false,
  eld_integrations: null,
  eld_integrations_have_loaded: false,
  eld_integration_id: null,
  // Rule sets that, when failed, will trigger
  // the ELD connection flow within the context
  // of an onboarding packet. Needs to stay
  // in sync with the backend
  eld_sensitive_rule_sets: [
    'has_eld_connected_and_active',
    'require_eld_for_ten_or_less_power_units',
    'require_eld_for_ten_or_less_power_units_with_contact_change',
    'has_verified_physical_location_activity_baseline',
    'has_verified_physical_location_activity',
  ],
  factor_office_options: [],
  post_onboard_broker_channel_is_types: ['macropoint', 'trucker_tools'],
  post_onboard_broker_channels: [],
  post_onboard_broker_channels_have_loaded: false,
  failing_eld_statuses: [
    'no_vins_on_coi',
    'missing_vins_on_eld',
    'some_eld_vin_matches_on_coi',
    'no_eld_vin_matches_on_coi',
    'no_active_vehicles_found_on_eld',
    'bipd_not_on_file',
    'eld_vins_not_on_coi',
  ],
  eld_status: '',
  trackingConfigs: null,
  eld_carrier_vehicles: {},
});

// getters
const getters = {};

// actions
const actions = {
  async updatePacket({ commit, state, rootState, dispatch }, payload) {
    commit(
      'addFormDebugMessage',
      "UPDATE PACKET CALL | VUEX | onboardingPacket.js: 'updatePacket' called",
      { root: true }
    );
    const body = payload.body;
    try {
      const res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets/' +
          rootState.onboardingPacket.onboarding_id,
        body
      );
      // Clear "onboardingPacketBody" if successful
      // to prepare for next update request
      if ([200, 201].includes(res.status)) {
        // First check for "onboardingPacketBody" having a tax_classification value in the contracts step. If so, auto-generate a w_9 form.
        if (
          state.viewed_step_name?.includes('Contract') &&
          state.onboarding_id > 0 &&
          ((state.onboardingPacketBody?.carrier?.tax_identifiers_attributes
            ?.length > 0 &&
            state.onboardingPacketBody?.carrier?.tax_classification?.length >
              0) ||
            (state?.current_stage > 8 &&
              rootState.carriers?.carrierData?.identity?.tax_identifiers
                ?.length > 0 &&
              state.carriers?.carrierData?.identity?.tax_classification
                ?.length > 0) ||
            (state?.current_stage > 8 &&
              rootState.carriers?.carrierData?.identity?.tax_identifiers
                ?.length > 0 &&
              state.onboardingPacketBody?.carrier?.tax_identifiers_attributes
                ?.length > 0))
        ) {
          if (
            state.onboardingPacketBody?.carrier?.tax_classification !==
            'foreign'
          ) {
            console.log('not-foreign - w9');
            if (
              rootState.taxQuestions?.has_canadian_address !== true &&
              [
                ...(state.onboardingPacketBody?.carrier
                  ?.tax_identifiers_attributes ?? []),
              ].some((tax) => tax?.is_type == 'ein' || tax?.is_type == 'ssn')
            ) {
              await dispatch(
                'taxQuestions/submitAutoW9TaxForm',
                state.onboarding_id,
                { root: true }
              );
              commit(
                'addFormDebugMessage',
                'UPDATE PACKET CALL | VUEX | onboardingPacket.js: dispatching submitAutoW9TaxForm',
                { root: true }
              );
            }
          } else {
            console.log('foreign - w8');
            // const timestamp = new Date(rootState.taxQuestions?.latest_tax_form_submissions?.[rootState?.taxQuestions?.current_tax_form]?.updated_at);
            // const currentTime = new Date();
            // const oneHourInMs = 60 * 60 * 1000;

            // const isWithinLastHour = currentTime - timestamp < oneHourInMs;
            // if (!isWithinLastHour || !rootState.taxQuestions?.latest_tax_form_submissions?.[rootState?.taxQuestions?.current_tax_form]?.onboarding_packet_id !== state.onboarding_id) {
            if (
              [
                ...(state.onboardingPacketBody?.carrier
                  ?.tax_identifiers_attributes ?? []),
              ].some((tax) =>
                rootState?.taxQuestions?.allW8Tins.includes(tax?.is_type)
              )
            ) {
              if (
                !(
                  rootState.taxQuestions?.latest_company_tax_form_submissions?.[
                    rootState?.taxQuestions?.current_tax_form
                  ]?.onboarding_packet_id == state.onboarding_id
                )
              ) {
                await dispatch(
                  'taxQuestions/submitAutoW8TaxForm',
                  state.onboarding_id,
                  { root: true }
                );
                commit(
                  'addFormDebugMessage',
                  'UPDATE PACKET CALL | VUEX | onboardingPacket.js: dispatching submitAutoW8TaxForm',
                  { root: true }
                );
              } else if (
                !rootState.taxQuestions?.latest_company_tax_form_submissions?.[
                  rootState?.taxQuestions?.current_tax_form
                ]?.signer?.name &&
                !rootState.taxQuestions?.latest_company_tax_form_submissions?.[
                  rootState?.taxQuestions?.current_tax_form
                ]?.signer?.signed_at &&
                !rootState.taxQuestions?.latest_tax_form_submission
              ) {
                await commit(
                  'taxQuestions/setLatestTaxFormSubmission',
                  rootState.taxQuestions?.latest_company_tax_form_submissions?.[
                    rootState?.taxQuestions?.current_tax_form
                  ],
                  { root: true }
                );
                commit(
                  'addFormDebugMessage',
                  'UPDATE PACKET CALL | VUEX | onboardingPacket.js: unsigned W-8 present for this packet - calling setLatestTaxFormSubmission',
                  { root: true }
                );
              } else {
                commit(
                  'addFormDebugMessage',
                  'UPDATE PACKET CALL | VUEX | onboardingPacket.js: NO unsigned W-8 present for this packet - NOT calling setLatestTaxFormSubmission',
                  { root: true }
                );
              }
            }
          }
        }
        if (!payload.no_reset) {
          await commit('setOnboardingPacket', {});
        }
        commit(
          'addFormDebugMessage',
          'UPDATE PACKET CALL | VUEX | onboardingPacket.js: Setting updated carrierData',
          { root: true }
        );
        await commit(
          'carriers/setCarrierData',
          { ...rootState.carriers.carrierData, ...res.data },
          { root: true }
        );

        // Hit "nextStepPatch" if successful and necessary (not a sub step)
        if (payload.canHitNextStep) {
          commit(
            'addFormDebugMessage',
            'NEXT | FROM UPDATE PACKET CALL | VUEX | onboardingPacket.js: canHitNextStep true, hitting next',
            { root: true }
          );
          const nextStepRes = await dispatch('nextStepPatch', {
            id: rootState.onboardingPacket.onboarding_id,
          });

          return nextStepRes;
        } else {
          commit(
            'addFormDebugMessage',
            'BYPASSING NEXT | FROM UPDATE PACKET CALL | VUEX | onboardingPacket.js: canHitNextStep false, not hitting next',
            { root: true }
          );
        }

        // return res;
      } else {
        if (!payload.no_reset) {
          await commit('setOnboardingPacket', {});
        }
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async updatePacketForFileUpload({ commit, rootState }, payload) {
    await commit('questions/setUploadingFile', true, { root: true });

    const body = payload;
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          processData: 'false',
        },
      };
      const res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets/' +
          rootState.onboardingPacket.onboarding_id,
        body,
        config
      );
      // Clear "onboardingPacketBody" if successful
      // to prepare for next update request
      if ([200, 201].includes(res?.status)) {
        await commit('questions/setUploadingFile', false, { root: true });
        await commit(
          'carriers/setCarrierData',
          { ...rootState.carriers.carrierData, ...res.data },
          { root: true }
        );
      } else {
        await commit('questions/setUploadingFile', false, { root: true });
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403].includes(e?.response?.status)) {
        return e.response;
      } else if (axios.isAxiosError(e) && [422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async executeContract({ commit, dispatch, rootState }) {
    try {
      const res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets/' +
          rootState.onboardingPacket.onboarding_id +
          '/execute_contract'
      );
      if ([200, 201].includes(res?.status)) {
        // next step after executing contract
        commit(
          'addFormDebugMessage',
          "EXECUTE CONTRACT CALL | VUEX | onboardingPacket.js: 'executeContract' called and returned " +
            res?.status,
          { root: true }
        );
        return await dispatch('nextStepPatch'); // first next takes us to "integrations" step (OLD - TO DO: remove this comment)
      }
    } catch (e) {
      // TODO delete 500 from array
      if (
        axios.isAxiosError(e) &&
        [403, 422, 500].includes(e?.response?.status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    } finally {
      await commit('setOnboardingPacket', {});
    }
  },
  async createPacket(_, body) {
    let formData = new FormData();
    formData.append('onboarding_packet[connection_id]', body.connection_id);

    try {
      const res = await axios.post(
        process.env.API_IDENTITY + '/api/v1/onboarding_packts/' + formData
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  // eslint-disable-next-line
  async getOnboardingPacket({ rootState }, payload) {
    // const body = payload.body;

    let buildParams = `page=1&per_page=50`;

    // If packet_id is present from the authorizations response,
    // use that to fetch the packet instead of the default sort
    const packet_id = rootState.authorizations?.packet_id;
    if (packet_id && packet_id > 0) {
      buildParams += `&q[id_eq]=${packet_id}`;
    } else {
      buildParams += `&q[s]=id desc`;
    }

    try {
      const res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/onboarding_packets?' + buildParams
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getOnboardingPacketById({ commit, dispatch }, body) {
    try {
      const res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/onboarding_packets/' + body.id
      );
      await commit('setOnboardingIdAndStatus', res.data);
      await commit(
        'carriers/setCarrierData',
        { ...placeholderFormData, ...res.data },
        { root: true }
      );
      if (
        [200, 201].includes(res?.status) &&
        res?.data?.identity?.identifiers?.length > 0
      ) {
        // why are we doing this by DOT?
        // const findDot = res.data.identity.identifiers.find(el => el.is_type === 'DOT')
        // if (findDot) {
        return await dispatch(
          'carriers/getCarriersDetail',
          {
            id: res.data.connection.carrier_id,
          },
          { root: true }
        );
        // return await dispatch('carriers/getCarriersDetail', res.data.identity.id, { root:true });
        // }
      }
      return res;
    } catch (e) {
      // set this so that the Thank You page will still load if no onboarding packet is found
      await commit('setPostOnboardBrokerConnectChannelsHaveLoaded', true);
      if (axios.isAxiosError(e) && [403, 422].includes(e.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  // eslint-disable-next-line
  async getConnection({ commit }, payload) {
    const buildParams = `page=1&per_page=50&q[s]=id desc`;
    try {
      const res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/connections/for_onboarding_portal?' +
          buildParams
      );
      await commit('setConnections', res.data);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  // eslint-disable-next-line
  async nextStepPatch({ dispatch, state, rootState, commit }, body) {
    console.log('running nextStepPatch');
    try {
      const res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets/' +
          rootState.onboardingPacket.onboarding_id +
          '/next'
      );
      // update user information / step information here
      if ([200, 201].includes(res.status)) {
        await commit(
          'carriers/setCarrierData',
          { ...rootState.carriers.carrierData, ...res.data },
          { root: true }
        );
        await commit('setOnboardingIdAndStatus', res.data);
        // if (res?.data?.stage == 7 && res?.data?.company_question_sections?.length == 0 && ['Payment-2', 'Payment-3'].includes(state?.viewed_step_name)) {
        //   // Auto-next if current stage is 7 and no question sections exist (may occur with conditional quesiton sections)
        //   dispatch('nextStepPatch');
        // } else {
        //   return res;
        // }
        return res;
        // return await dispatch('getOnboardingPacketById', {id: res.data.id});
      }
      // return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async createDispatcherOnBoardingPacket({ commit, dispatch }, data) {
    const body = data;

    // TODO - It is neccessary to update this function to accept issuer_id.
    let formData = new FormData();
    formData.append('carrier_id', body.carrier_id);
    formData.append('client_id', body.client_id);
    try {
      let res = await axios.post(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets/find_or_create_connection_and_create_onboarding_packet',
        formData
      );

      commit(
        'carriers/setCarrierData',
        { ...placeholderFormData, ...res.data },
        { root: true }
      );
      await commit('setOnboardingIdAndStatus', res.data);
      if (res?.data?.identity?.id) {
        await dispatch('carriers/getCarriersDetail', res.data.identity.id, {
          root: true,
        });
      }

      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 424, 423].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async onboardingId({ commit }, body) {
    await commit('setOnboardingPacket', body);
  },
  setOnboardingBody({ commit }, body) {
    commit('setOnboardingPacket', body);
  },
  async getConnectSubscriptions({ rootState, commit }) {
    let issuer_id = rootState.carriers.carrierData?.connection?.issuer_id;
    let ransack = '';
    if (issuer_id) {
      ransack = '?q[channel_issuer_id_eq]=' + issuer_id;
    }
    try {
      const res = await axios.get(
        process.env.API_MONITOR + '/connect/api/v1/integrations' + ransack
      );
      await commit('setConnectSubscriptions', res.data);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getBrokerConnectChannels({ commit }, issuer_id) {
    const buildParams = `page=1&per_page=50&q[s]=name asc&q[is_active_true]=1&q[issuer_id_eq]=${issuer_id}`;
    try {
      const res = await axios.get(
        process.env.API_CONNECT + '/connect/api/v1/channels?' + buildParams
      );
      if ([200, 201].includes(res.status)) {
        await commit('setBrokerConnectChannels', res.data);
        return res;
      }
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getLatestCompletedOnboardingPacket({ commit, dispatch }) {
    try {
      const res = await axios.get(
        process.env.API_CONNECT +
          '/api/v1/onboarding_packets?q[status_eq]=complete&q[s]=updated_at+desc&per_page=1'
      );
      if ([200, 201].includes(res?.status)) {
        console.log('getLatestCompletedOnboardingPacket res:', res);
        await dispatch('getOnboardingPacketById', { id: res.data?.[0]?.id });
        await dispatch('getConnectSubscriptions');
        return res;
      }
    } catch (e) {
      // set this so that the Thank You page will still load if no onboarding packet is found
      await commit('setPostOnboardBrokerConnectChannelsHaveLoaded', true);
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getPostOnboardBrokerConnectChannels({ commit, state }, issuer_id) {
    let channel_is_types = state.post_onboard_broker_channel_is_types;
    let isTypeParams = '';
    if (channel_is_types?.length > 0) {
      channel_is_types.forEach((el) => {
        isTypeParams += `&q[is_type_in][]=${el}`;
      });
    }
    const buildParams = `page=1&per_page=50&q[s]=name asc&q[is_active_true]=1&q[issuer_id_eq]=${issuer_id}${isTypeParams}&q[is_shown_in_integrations_step_false]=1`;
    // const buildParams = `page=1&per_page=50&q[s]=name asc&q[is_active_true]=1&q[issuer_id_eq]=${issuer_id}${isTypeParams}`;
    try {
      const res = await axios.get(
        process.env.API_MONITOR + '/connect/api/v1/channels?' + buildParams
      );
      if ([200, 201].includes(res.status)) {
        await commit('setPostOnboardBrokerConnectChannels', res.data);
        await commit('setPostOnboardBrokerConnectChannelsHaveLoaded', true);
        return res;
      }
    } catch (e) {
      await commit('setPostOnboardBrokerConnectChannelsHaveLoaded', true);
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getEldProviders({ commit, state }) {
    const perPage = 500;
    let allProviders = [];
    commit('setIsEldProvidersLoading', true);
    try {
      const initialRes = await axios.get(
        `${process.env.API_MONITOR}/connect/api/v1/channels?q[issuer_id_eq]=1&q[is_active_true]=1&q[eld_type_not_null]=1&q[s]=id+asc&page=1&per_page=${perPage}`
      );

      const totalPages = parseInt(initialRes.headers.totalpages, 10) || 1;
      const totalItems = parseInt(initialRes.headers.totalitems, 10) || 0;

      allProviders = initialRes.data;

      const requests = [];
      for (let page = 2; page <= totalPages; page++) {
        requests.push(
          axios.get(
            `${process.env.API_MONITOR}/connect/api/v1/channels?q[issuer_id_eq]=1&q[is_active_true]=1&q[eld_type_not_null]=1&q[s]=id+asc&page=${page}&per_page=${perPage}`
          )
        );
      }

      const responses = await Promise.all(requests);

      responses.forEach((res) => {
        if (res?.data?.length > 0) {
          allProviders = allProviders.concat(res.data);
        }
      });

      await commit('setEldProviders', allProviders);

      let oauthProviders = allProviders.filter(
        (provider) => provider?.retrieval_type === 'oauth'
      );
      await commit('setOauthProviders', oauthProviders);
      commit('setIsEldProvidersLoading', false);

      if (state.totalEldCount == null) {
        await commit('setTotalEldCount', totalItems);
      }

      return allProviders;
    } catch (e) {
      commit('setIsEldProvidersLoading', false);
      if (
        axios.isAxiosError(e) &&
        [401, 403, 422].includes(e?.response?.status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getLatestEldProvider({ commit, dispatch }, payload) {
    // Backward compatible: accept carrier_id or { carrier_id, onboarding_packet_id }
    const carrier_id =
      typeof payload === 'object' ? payload.carrier_id : payload;
    const onboarding_packet_id =
      typeof payload === 'object' ? payload.onboarding_packet_id : null;

    commit('setHasLatestEldProviderLoaded', false);
    try {
      let url =
        process.env.API_MONITOR +
        '/api/v1/carrier_eld_providers?page=1&per_page=1&q[carrier_id_eq]=' +
        carrier_id +
        '&q[s]=id+desc';

      if (onboarding_packet_id) {
        url += '&q[onboarding_packet_id_eq]=' + onboarding_packet_id;
      }

      const res = await axios.get(url);
      if (res?.data && res?.data?.length > 0) {
        await commit('setLatestCarrierEldProvider', res?.data?.[0]);
      } else if (onboarding_packet_id) {
        // No provider for this packet. Do an unscoped fetch to find the
        // carrier's most recent provider and auto-create one for this packet
        // using the same connect_channel.
        const unscopedUrl =
          process.env.API_MONITOR +
          '/api/v1/carrier_eld_providers?page=1&per_page=1&q[carrier_id_eq]=' +
          carrier_id +
          '&q[s]=id+desc';
        const unscopedRes = await axios.get(unscopedUrl);
        if (unscopedRes?.data?.[0]?.connect_channel?.id) {
          await dispatch(
            'createCarrierEldProvider',
            unscopedRes.data[0].connect_channel.id
          );
        } else {
          await commit('setLatestCarrierEldProvider', null);
        }
      }
      commit('setHasLatestEldProviderLoaded', true);
      return res;
    } catch (e) {
      commit('setHasLatestEldProviderLoaded', true);
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getEldProviderByConnectId({ commit }, { carrier_id, connect_id }) {
    try {
      const res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/carrier_eld_providers?page=1&per_page=1&q[carrier_id_eq]=' +
          carrier_id +
          '&q[connect_channel_id_eq]=' +
          connect_id +
          '&q[s]=id+desc'
      );
      if (res?.data && res?.data?.length > 0) {
        await commit('setLatestCarrierEldProvider', res?.data?.[0]);
      }
      await commit('setLatestCarrierEldProviderHasLoaded', true);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getEldProviderById({ commit }, eld_provider_id) {
    try {
      const res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/carrier_eld_providers/' +
          eld_provider_id
      );
      if (res?.data && res?.data?.id > 0) {
        await commit('setLatestCarrierEldProvider', res?.data);
      }
      await commit('setLatestCarrierEldProviderHasLoaded', true);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getEldIntegrationById({ commit }, eld_integration_id) {
    try {
      const res = await axios.get(
        process.env.API_MONITOR +
          '/connect/api/v1/integrations/' +
          eld_integration_id
      );
      if (res?.data && res?.data?.id > 0) {
        await commit('setCurrentEldIntegration', res?.data);
      }
      await commit('setCurrentEldIntegrationHasLoaded', true);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getMostRecentEldIntegration({ commit, rootState, state }) {
    try {
      let company_id = rootState.users?.currentUser?.company?.id;
      const res = await axios.get(
        process.env.API_MONITOR +
          '/connect/api/v1/integrations?q[company_id_eq]=' +
          company_id +
          '&q[s]=id+desc&page=1&per_page=1'
      );
      if (
        res?.data &&
        res?.data?.[0]?.id > 0 &&
        state.current_eld_integration == null
      ) {
        await commit('setCurrentEldIntegration', res?.data?.[0]);
        await commit('setMostRecentEldIntegration', res?.data?.[0]);
      }
      await commit('setCurrentEldIntegrationHasLoaded', true);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getEldIntegrations({ commit }, company_id) {
    try {
      const res = await axios.get(
        process.env.API_MONITOR +
          '/connect/api/v1/integrations?q[channel_eld_type_not_null]=1&q[channel_is_active_true]=1&q[company_id_eq]=' +
          company_id +
          '&q[s]=id+desc&page=1'
      );

      if (res?.data) {
        await commit('setEldIntegrations', res?.data);
      }
      await commit('setEldIntegrationsHasLoaded', true);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async createCarrierEldProvider({ commit, state }, connect_channel_id) {
    let body = {
      carrier_eld_provider: {
        connect_channel_id: connect_channel_id,
        onboarding_packet_id: state.onboarding_id ? state.onboarding_id : null,
        /* carrier_id: rootState.carriers.carrierData?.connection?.carrier_id
          ? rootState.carriers.carrierData?.connection?.carrier_id
          : rootState.users?.currentUser?.company?.carrier_id,
        
        user_id: rootState.users.currentUser?.id, */
      },
    };
    try {
      const res = await axios.post(
        process.env.API_MONITOR + '/api/v1/carrier_eld_providers',
        body
      );
      if (res?.data) {
        await commit('setLatestCarrierEldProvider', res.data);
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async updateCarrierEldProvider({ commit }, { id, body }) {
    try {
      const res = await axios.patch(
        process.env.API_MONITOR +
          '/api/v1/carrier_eld_providers/' +
          id +
          '/update_with_integration_changes',
        body
      );
      if (res?.data) {
        await commit('setLatestCarrierEldProvider', res.data);
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async updateCarrierEldProviderForCertificationInvite({ commit }, id) {
    try {
      let body = {
        carrier_eld_provider: {
          has_sent_certification_invite: true,
        },
      };
      const res = await axios.patch(
        process.env.API_MONITOR + '/api/v1/carrier_eld_providers/' + id,
        body
      );
      if (res?.data) {
        await commit('setLatestCarrierEldProvider', res.data);
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async refreshEldProvider(_, eld_integration_id) {
    try {
      const res = await axios.patch(
        process.env.API_MONITOR +
          '/connect/api/v1/integrations/' +
          eld_integration_id +
          '/import_eld_verifications'
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async removeEldProvider(_, eld_integration_id) {
    try {
      const res = await axios.patch(
        process.env.API_MONITOR +
          '/connect/api/v1/integrations/' +
          eld_integration_id +
          '/inactivate'
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async updateApiCarrierEldProvider({ commit }, { id, body }) {
    try {
      const res = await axios.patch(
        process.env.API_MONITOR +
          '/api/v1/carrier_eld_providers/' +
          id +
          '/update_with_integration_changes',
        body
      );
      if (res?.data) {
        await commit('setLatestCarrierEldProvider', res.data);
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async uploadCarrierEldProviderDocuments(
    { commit },
    { id, title_uploads, cab_card_uploads, drivers_license_uploads }
  ) {
    let body = new FormData();
    if (title_uploads?.length > 0) {
      title_uploads.forEach((file) => {
        body.append('title_uploads[]', file);
      });
    }
    if (cab_card_uploads?.length > 0) {
      cab_card_uploads.forEach((file) => {
        body.append('cab_card_uploads[]', file);
      });
    }
    if (drivers_license_uploads?.length > 0) {
      drivers_license_uploads.forEach((file) => {
        body.append('drivers_license_uploads[]', file);
      });
    }
    console.log('uploadCarrierEldProviderDocuments body');
    console.dir(body);

    try {
      const res = await axios.post(
        process.env.API_MONITOR +
          '/api/v1/carrier_eld_providers/' +
          id +
          '/upload_exempt_documents',
        body
      );
      if (res?.data) {
        await commit('setLatestCarrierEldProvider', res.data);
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async updateEldIntegrationId({ commit }, id) {
    await commit('setEldIntegrationId', id);
  },
  async getFactorOfficeOptions({ commit, state }) {
    try {
      const res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/onboarding_packets/' +
          state.onboarding_id +
          '/jb_hunt_factor_office_options'
      );
      if (res?.data) {
        await commit('setFactorOfficeOptions', res.data);
      } else {
        await commit('setFactorOfficeOptions', []);
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getEldStatus({ rootState, state }, carrierId = null) {
    let carrier_id;
    if (carrierId) {
      carrier_id = carrierId;
    } else if (state.id > 0) {
      carrier_id = rootState.carriers.carrierData?.connection?.carrier_id;
    } else {
      carrier_id = state.latest_carrier_eld_provider?.carrier_id;
    }

    let res;
    if (!carrier_id || carrier_id < 1) {
      res = { status: 404, data: {} };
      return res;
    }
    try {
      res = await axios.get(
        process.env.API_MONITOR + `/api/v1/carriers/${carrier_id}/eld_status`
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        res = e?.response;
        return res;
      }
    }
  },
  async getTrackingConfigsByCompanyId(_, companyId) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/marketing_tracking_configs/by_company/${companyId}`
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        throw e;
      } else {
        throw e;
      }
    }
  },
  async createTrackingConfigs(_, { is_type, value, onboardingPacketId }) {
    const body = {
      tracking_entry: {
        is_type,
        value,
      },
    };
    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/onboarding_packets/${onboardingPacketId}/marketing_tracking_entries`,
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        throw e;
      } else {
        throw e;
      }
    }
  },
  async getEldVehichleInformation({ commit }, carrier_id) {
    let res;
    if (!carrier_id || carrier_id < 1) {
      res = { status: 404, data: {} };
      return res;
    }
    try {
      res = await axios.get(
        process.env.API_MONITOR +
          `/api/v1/carriers/${carrier_id}/eld_carrier_vehicles_for_carrier`
      );
      await commit('setEldCarrierVehicles', res?.data);
    } catch (e) {
      if (axios.isAxiosError(e)) {
        res = e?.response;
        return res;
      }
    }
  },
  async verifyTin({ state }, { tin_type, tin, legal_name }) {
    try {
      const body = {
        tin_type: tin_type?.toUpperCase(),
        tin: tin?.replace(/\D/g, ''),
      };

      if (legal_name) {
        body.legal_name = legal_name;
      }

      const res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets/' +
          state.onboarding_id +
          '/verify_tin',
        body
      );

      return res;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setOnboardingPacket(state, el) {
    state.onboardingPacketBody = el;
  },
  setOnboardingIdAndStatus(state, el) {
    state.onboarding_id = el.id;
    state.id = el.id;
    state.current_stage = el.stage;
    state.status = el.status;
  },
  setConnections(state, el) {
    state.connections = el;
  },
  setConnectSubscriptions(state, el) {
    state.connect_subscriptions = el;
  },
  setBrokerConnectChannels(state, el) {
    state.broker_connect_channels = el;
  },
  setViewedStepName(state, el) {
    state.viewed_step_name = el;
  },
  setIsEldProvidersLoading(state, bool) {
    state.isEldProvidersLoading = bool;
  },
  setEldProviders(state, data) {
    state.eld_providers = data;
    if (data?.length > 0) {
      state.certified_eld_providers = [];
      data?.forEach((el) => {
        if (el?.is_certified_eld && el?.eld_type != 'eld_exempt') {
          state.certified_eld_providers.push(el);
        }
      });
    }
  },
  setOauthProviders(state, data) {
    state.oauth_eld_providers = data;
  },
  setTotalEldCount(state, data) {
    state.totalEldCount = data;
  },
  setLatestCarrierEldProvider(state, data) {
    state.latest_carrier_eld_provider = data;
  },
  setHasLatestEldProviderLoaded(state, bool) {
    state.hasLatestEldProviderLoaded = bool;
  },
  setTaxClassification(state, data) {
    state.tax_classification = data;
  },
  setTaxIdentifiersAttributes(state, data) {
    state.tax_identifiers_attributes = [];
    state.tax_identifiers_attributes.push(data);
  },
  setHasAttemptedCompletedRedirect(state, bool) {
    state.has_attempted_completed_redirect = bool;
  },
  setCurrentEldIntegration(state, data) {
    state.current_eld_integration = data;
  },
  setMostRecentEldIntegration(state, data) {
    state.most_recent_eld_integration = data;
  },
  setCurrentEldIntegrationHasLoaded(state, bool) {
    state.current_eld_integration_has_loaded = bool;
  },
  setEldIntegrations(state, data) {
    state.eld_integrations = data;
  },
  setEldIntegrationsHasLoaded(state, bool) {
    state.eld_integrations_have_loaded = bool;
  },
  setEldIntegrationId(state, data) {
    state.eld_integration_id = data;
  },
  setFactorOfficeOptions(state, data) {
    state.factor_office_options = data;
  },
  setPostOnboardBrokerConnectChannels(state, data) {
    state.post_onboard_broker_channels = data;
  },
  setPostOnboardBrokerConnectChannelsHaveLoaded(state, bool) {
    state.post_onboard_broker_channels_have_loaded = bool;
  },
  setEldStatus(state, data) {
    state.eld_status = data;
  },
  setEldCarrierVehicles(state, data) {
    state.eld_carrier_vehicles = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
